import React, { useState } from "react";
import "./sidebar.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import StoreIcon from "@mui/icons-material/Store";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link } from "react-router-dom";
import { signout } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { setActiveStore } from "../../redux/slices/storeSlice";

const Sidebar = () => {
  const { stores } = useSelector((state) => state?.listStores);
  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(signout());
    window.location.reload();
  };
  const handleStoreId = (id) => {
    dispatch(setActiveStore(id));
  };
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className="sidebar fixed left-0 top-0 md:w-[14%] w-[45%] bg-white z-[100] h-[100vh] border border-gray-300">
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo-bits">Bits</span>
          <span className="logo-hub">hub</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/" style={{ textDecoration: "none" }}>
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <p className="title">LISTS</p>
          <Link to="/products" style={{ textDecoration: "none" }}>
            <li>
              <StoreIcon className="icon" />
              <span>My Products</span>
            </li>
          </Link>
          <Link to="/all-products" style={{ textDecoration: "none" }}>
            <li>
              <CreditCardIcon className="icon" />
              <span>All Products</span>
            </li>
          </Link>
          {/* <Link to="/all-stores" style={{ textDecoration: "none" }}>
            <li>
              <StoreIcon className="icon" />
              <span>All Stores</span>
            </li>
          </Link> */}
          <Link to="/category" style={{ textDecoration: "none" }}>
            <li>
              <StoreIcon className="icon" />
              <span>All Categories</span>
            </li>
          </Link>

          {/* <li>
            <LocalShippingIcon className="icon" />
            <span>Delivery</span>
          </li>
          <p className="title">USEFUL</p>
          <li>
            <InsertChartIcon className="icon" />
            <span>Stats</span>
          </li>
          <li>
            <NotificationsNoneIcon className="icon" />
            <span>Notifications</span>
          </li>
          <p className="title">SERVICE</p>
          <li>
            <SettingsSystemDaydreamOutlinedIcon className="icon" />
            <span>System Health</span>
          </li>
          <li>
            <PsychologyOutlinedIcon className="icon" />
            <span>Logs</span>
          </li>
          <li>
            <SettingsApplicationsIcon className="icon" />
            <span>Settings</span>
          </li> */}
          <p className="title">SWITCH</p>
          <div onClick={handleClick} className="text-[#888] text-[13px]">
            <li>
              <PersonOutlineIcon className="icon" />
              <span>Stores</span>
              {open ? <ExpandLess /> : <ExpandMore />}{" "}
            </li>
          </div>
          <div className="text-[#888] text-sm">
            <Collapse in={open} timeout="auto" unmountOnExit>
              <div className="pl-2">
                {stores?.data?.map((item) => {
                  return (
                    <Link key={item.id} onClick={() => handleStoreId(item.id)}>
                      <li>
                        <PersonOutlineIcon className="icon" />
                        <span>{item?.brand_name}</span>
                      </li>
                    </Link>
                  );
                })}
              </div>
            </Collapse>
          </div>
          <p className="title">USER</p>
          <Link to="/profile">
            <li>
              <AccountCircleOutlinedIcon className="icon" />
              <span>Profile</span>
            </li>
          </Link>

          <li>
            <ExitToAppIcon className="icon" />
            <span onClick={logoutHandler}>Logout</span>
          </li>
        </ul>
      </div>

      <div className="bottom">
        <div
          className="colorOption"
          // onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          // onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  );
};

export default Sidebar;
